import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../state/hooks'
import { setDefaults, fromAddress, OutputFormat } from 'react-geocode'
import { GOOGLE_API_KEY } from '@env'
import { setUserState } from '../state/Slices/userSlice'
import { Platform } from 'react-native'

const useLocation = () => {
	const { userLocation } = useAppSelector(state => state.user)
	const { isDelivery } = useAppSelector(state => state.persisted)

	const dispatch = useAppDispatch()

	useEffect(() => {
		if (Platform.OS !== 'web') return
		setDefaults({
			key: GOOGLE_API_KEY,
			language: 'en',
			region: 'es',
			outputFormat: OutputFormat.JSON,
		})
		if (userLocation.longAddress && isDelivery) {
			getFromAddress()
		} else if (navigator.geolocation) {
			getLocation()
		} else {
			getFromIp()
		}
	}, [userLocation?.longAddress, navigator.geolocation, isDelivery])
	const getFromAddress = () => {
		fromAddress(userLocation.longAddress).then(({ results }) => {
			const { lat, lng } = results[0].geometry.location
			const location = {
				userLocation: {
					...userLocation,
					coordinates: { lat, lng, error: null, type: 'address' },
				},
			}
			console.log({ location })
			dispatch(setUserState(location))
		})
	}
	const getFromIp = () => {
		fetch('https://ipapi.co/json/')
			.then(response => response.json())
			.then(data => {
				const location = {
					userLocation: {
						...userLocation,
						coordinates: {
							lat: data.latitude,
							lng: data.longitude,
							error: null,
							type: 'ip',
						},
					},
				}
				console.log({ location })

				dispatch(setUserState(location))
			})
			.catch(err => {
				const location = {
					userLocation: {
						...userLocation,
						coordinates: { lat: null, lng: null, error: JSON.stringify(err), type: 'ip' },
					},
				}
				console.log({ location })

				dispatch(setUserState(location))
			})
	}
	const getLocation = () => {
		if (!navigator.geolocation) {
			getFromIp()
			return
		}

		navigator.geolocation.getCurrentPosition(
			position => {
				const location = {
					userLocation: {
						...userLocation,
						coordinates: {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
							error: null,
							type: 'geolocation',
						},
					},
				}
				console.log({ location })

				dispatch(setUserState(location))
			},
			err => {
				getFromIp()
			}
		)
	}
	return { userLocation }
}
export default useLocation
